import { type ApiFilter, type CreateFilterProps } from "iqf-web-ui/data-table";
import { type DeriveSortingFn } from "iqf-web-ui/data-table-utils";
import { type SelectOptionType } from "iqf-web-ui/select";

const UDZS_TYPE_OPERATION = "UDZS_TYPE";

export const UDZS_TYPE_SORT_ID = "__UDZS_TYPE__";

type UdzsTypeFilter = {
  field: null;
  operation: typeof UDZS_TYPE_OPERATION;
  value: string;
};

function toApiFilter(filter: UdzsTypeFilter): ApiFilter {
  // iqf-web-ui does not model application-specific browse operations.
  return filter as unknown as ApiFilter;
}

export function createUdzsTypeFilter(value: string): ApiFilter {
  return toApiFilter({
    operation: UDZS_TYPE_OPERATION,
    value,
    field: null,
  });
}

export function createUdzsTypeEnumFilter({
  filterValue,
}: CreateFilterProps<SelectOptionType>): ApiFilter {
  const filters = filterValue.map((value) => createUdzsTypeFilter(value.id));

  if (filters.length === 1) {
    return filters[0];
  }

  return {
    operation: "OR",
    filters,
  };
}

export function deriveUdzsSorting(
  mappedSortingState: Parameters<DeriveSortingFn>[0],
): ReturnType<DeriveSortingFn> {
  const sorts = mappedSortingState.map((sort) => {
    if (sort.id === UDZS_TYPE_SORT_ID) {
      return {
        type: UDZS_TYPE_OPERATION,
        asc: !sort.desc,
        nullPrecedence: sort.nullPrecedence,
      };
    }

    return {
      field: sort.id,
      type: "FIELD",
      asc: !sort.desc,
      nullPrecedence: sort.nullPrecedence,
    };
  });

  // iqf-web-ui does not model application-specific browse sort types.
  return { sorts } as ReturnType<DeriveSortingFn>;
}
